import { store } from "@store";
import { logoutSuccess, selectToken } from "@store/slices/authSlice";
import { errorToast } from "@utils/toast";
import { AxiosError, InternalAxiosRequestConfig } from "axios";

// Flag to track if an auth error toast has been shown recently
let authErrorToastShown = false;
let authErrorToastTimer: NodeJS.Timeout | null = null;

// Reset the auth error toast flag after a delay
const resetAuthErrorToastFlag = () => {
  if (authErrorToastTimer) {
    clearTimeout(authErrorToastTimer);
  }

  authErrorToastTimer = setTimeout(() => {
    authErrorToastShown = false;
    authErrorToastTimer = null;
  }, 3000); // Reset after 3 seconds
};

export const requestSuccess = (config: InternalAxiosRequestConfig) => {
  const token = selectToken(store.getState());

  if (token) {
    // Add authorization token to headers if user is authenticated
    config.headers.Authorization = `Token ${token}`;
  }

  return config;
};

export const requestFailure = async (error: AxiosError) => {
  // Extract error details
  const status = error.response?.status;
  const isAuthError = status === 401 || status === 403;

  // Safely extract error message with proper type checking
  let errorMessage = "An error occurred";
  if (error.response?.data && typeof error.response.data === "object") {
    const data = error.response.data as Record<string, any>;

    // Some endpoints return { body: ["...message..."] }
    if (
      Array.isArray(data.body) &&
      data.body.length > 0 &&
      typeof data.body[0] === "string"
    ) {
      errorMessage = data.body[0];
    }

    if (data.detail && typeof data.detail === "string") {
      errorMessage = data.detail;
    }

    if (data.message && typeof data.message === "string") {
      errorMessage = data.message;
    }
  } else if (error.message) {
    errorMessage = error.message;
  }

  // For auth errors (401/403), only show the toast if one hasn't been shown recently
  if (isAuthError) {
    if (!authErrorToastShown) {
      authErrorToastShown = true;

      console.log("Session expired, please login again");

      // return;

      alert("Session expired, please login again");

      // errorToast("Error", errorMessage);
      resetAuthErrorToastFlag();

      // Handle unauthorized access
      store.dispatch(logoutSuccess());

      // Redirect to login page
      window.location.href = "/#/auth/signin";
    }
  } else {
    // Special handling for 404 when fetching projects list
    if (
      (error.config?.url?.includes("/project/v1/list") ||
        error.config?.url?.includes("/client/v1/list") ||
        error.config?.url?.includes("/user/v1/list") ||
        error.config?.url?.includes("/project/v1/time/list")) &&
      status === 404
    ) {
      return Promise.reject(error);
    }

    // For non-auth errors, always show the toast
    errorToast("Error", errorMessage);
  }

  return Promise.reject(error);
};
